// extracted by mini-css-extract-plugin
export default {"description":"account-profile-tfa_description__LVG++","actions":"account-profile-tfa_actions__peWFg","actionBtn":"account-profile-tfa_actionBtn__OGzRW"};